<!-- 发票提取单据 -->
<template>
    <div>
        <el-form :inline="true" class="demo-form-inline" size="mini">
            <el-form-item label="业务单号">
                <el-input clearable v-model.trim="invoiceExtractData.businessId" maxlength="64"></el-input>
            </el-form-item>
            <el-form-item label="销售订单号">
                <el-input clearable v-model.trim="invoiceExtractData.professId" maxlength="64"></el-input>
            </el-form-item>
            <el-form-item label="病人姓名">
                <el-input clearable v-model.trim="invoiceExtractData.patientName" maxlength="64"></el-input>
            </el-form-item>
            <el-form-item label="住院号">
                <el-input clearable v-model.trim="invoiceExtractData.courtNum" maxlength="64"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="searchData">查询</el-button>
            </el-form-item>
        </el-form>
        <!-- 表格 -->
        <el-table ref="moviesTable" height="420" size="mini" style="width: 100%" :data="mainData" border stripe highlight-current-row :header-cell-style="getHeaderCellStyle" @row-dblclick="dblclick"
                  @select="selectChange" @select-all="selectChangeAll">
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column align="center" min-width="150" prop="businessId" label="业务单号" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="150" prop="professId" label="销售订单号" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="businessType" label="订单类型" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="depName" label="业务部门" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="opmName" label="业务员名称" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="salesName" label="供货商业务员" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="160" prop="cmName" label="销售单位" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="totalNumber" label="总数量" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="oldMoney" label="总金额" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="patientName" label="病人姓名" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="courtNum" label="住院号" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination v-if="isPagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" background :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
        <el-collapse v-model="activeName" accordion>
            <el-collapse-item name="1" :disabled="true">
                <template slot="title">
                    <el-switch style="display: block" @change="showDetailChange" v-model="showdetail" active-text="展示明细" inactive-text="关闭明细">
                    </el-switch>
                    <el-button v-if="isDetail||returnObj.mainData.length>0" size="mini" @click="sureDetail" style="margin-left: 60px" type="primary">确认选择</el-button>
                    <el-tag v-else size="mini" style="margin-left: 60px">明细表格</el-tag>
                </template>
                <!-- 明细表 -->
                <el-table size="mini" height="280" :data="detailData" border stripe highlight-current-row :header-cell-style="getHeaderCellStyleD" style="width: 100%">
                    <el-table-column align="center" min-width="150" prop="businessId" label="业务单号" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="160" prop="bgmName" label="通用名称" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="100" prop="spec" label="规格" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="160" prop="manufacturer" label="生产厂商" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="120" prop="businessType" label="订单类型" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="120" prop="prodate" label="生产日期" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <span v-if="scope.row.prodate">
                                {{ $common.getLocalTime(scope.row.prodate) }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" min-width="120" prop="expidate" label="有效期" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <span v-if="scope.row.expidate">
                                {{ $common.getLocalTime(scope.row.expidate) }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" min-width="120" prop="outRate" label="销项税率" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="120" prop="price" label="单价" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="120" prop="money" label="金额" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="120" prop="psprice" label="含税价格" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="120" prop="psmoney" label="含税金额" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="120" prop="treatCount" label="待开票数量" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="120" prop="batchno" label="批号" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" min-width="120" prop="sterBatchno" label="灭菌批号" :show-overflow-tooltip="true"></el-table-column>
                </el-table>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
export default {
    name: "SalesInvoiceExtract",
    components: {},
    data() {
        return {
            opmId: "",
            ormId: "",
            activeName: "1",//默认展开
            showdetail: true,
            detailData: [],
            currentPage: 1,
            pageSizes: [10, 25, 50, 100],
            pageSize: 10,
            total: 0,
            mainData: [],
            selectedDataIndexList: [],
            isPagination: "",
            searchTermList: [], //检索条件
            Columns: [],
            ColumnsDetail: [],
            isDetail: false,
            multipleSelection: [], //数组内层
            returnObj: {//外层对象数据
                mainData: [],
                detailData: []
            },
        };
    },

    props: {
        invoiceExtractData: {
            type: Object,
            require: true
        },
    },
    watch: {},
    computed: {},
    mounted() { },
    created() {
        // 处理组件需要的数据
        this.opmId = JSON.parse(sessionStorage.getItem("userInfo")).opmId
        this.getTableMainList()
    },
    methods: {
        //明细隐藏
        showDetailChange(e) {
            e == true ? (this.activeName = "1") : (this.activeName = "0");
        },
        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getTableMainList()
        },
        searchData() {
            this.returnObj.mainData = []
            this.detailData = []
            this.getTableMainList()
        },
        selectChange(selection, row) {
            if (selection.filter(val => row.dasmId == val.dasmId).length == 0) {
                this.returnObj.mainData = this.returnObj.mainData.filter(item => item.wobkemId != row.wobkemId)
            } else {
                var arr = []
                if (window.global_config.salesInvoiceShow) {
                    arr = this.mainData.filter(val => val.wobkemId == row.wobkemId)
                } else {
                    arr.push(row)
                }
                if (arr.length > 0) {
                    this.returnObj.mainData.push(...arr)
                }

            }
            if (this.returnObj.mainData.length == 0) {
                this.$refs.moviesTable.clearSelection()
            } else {
                this.$refs.moviesTable.clearSelection()
                this.returnObj.mainData.forEach(item => {
                    this.$refs.moviesTable.toggleRowSelection(item, true)
                })
            }
            this.selectedDataIndexList = []
            this.returnObj.mainData.forEach(v => {
                this.selectedDataIndexList.push(v.dasmId)
            })
            if (this.selectedDataIndexList.length > 0) {
                this.getTableDetailList()
            }
            if (this.selectedDataIndexList.length == 0) {
                this.detailData = []
            }

        },
        selectChangeAll(selection) {
            this.returnObj.mainData = selection
            this.returnObj.mainData.forEach(item => {
                this.$refs.moviesTable.toggleRowSelection(item, true)
            })
            this.selectedDataIndexList = []
            this.returnObj.mainData.forEach(v => {
                this.selectedDataIndexList.push(v.dasmId)
            })
            if (this.selectedDataIndexList.length > 0) {
                this.getTableDetailList()
            }
            if (this.selectedDataIndexList.length == 0) {
                this.detailData = []
            }
        },
        dblclick(row) {
            var flag = false
            this.returnObj.mainData.forEach((item, index) => {
                if (item.businessId == row.businessId) {
                    flag = true
                    this.$refs.moviesTable.toggleRowSelection(row, false)
                    this.returnObj.mainData.splice(index, 1)
                }
            })
            if (!flag) {
                this.$refs.moviesTable.toggleRowSelection(row, true)
                this.returnObj.mainData.push(row)
            }
            this.selectedDataIndexList = []
            this.returnObj.mainData.forEach(v => {
                this.selectedDataIndexList.push(v.dasmId)
            })
            if (this.selectedDataIndexList.length > 0) {
                this.getTableDetailList()
            }
            if (this.selectedDataIndexList.length == 0) {
                this.detailData = []
            }
        },
        //确认选择
        sureDetail() {
            this.returnObj.detailData = JSON.parse(JSON.stringify(this.detailData))
            this.returnObj.mainData.sort(function (a, b) {
                return b.createTime - a.createTime
            })
            this.returnObj.detailData.sort(function (a, b) {
                return b.createTime - a.createTime
            })
            this.$emit("invoiceExtractMethods", this.returnObj);
        },
        // 获取主表格
        async getTableMainList() {
            let res = await this.$http.extractSudocumentsMaster(this.invoiceExtractData)
            if (res && res.status == 200) {
                this.mainData = res.result; //默认第一条
            } else {
                this.$message({
                    message: res.message,
                    type: 'error'
                });
                this.$emit("invoiceExtractMethods", '')
                return false
            }
        },
        // 获取明细表格
        async getTableDetailList() {
            let res = await this.$http.extractSudocumentsDetail({ "ids": this.selectedDataIndexList })
            if (res && res.status == 200) this.detailData = res.result
            this.isDetail = this.detailData.length > 0 ? true : false
        },
        //分页
        handleSizeChange(val) {
            this.pageSize = val;
            this.invoiceExtractData.rows = val;
            this.getTableMainList();
        },
        // 分页
        handleCurrentChange(val) {
            this.currentPage = val;
            this.invoiceExtractData.page = val;
            this.getTableMainList();
        },
        //   -----------------------------------------------------
        getHeaderCellStyle() {
            return "background: skybule; borderBottom: solid 1px #5a5e66;color: #3e5569";
        },
        getHeaderCellStyleD() {
            return "background: skybule;color: #3e5569";
        },

    },
};
</script>

<style scoped>
.el-pagination {
    padding: 20px 0px 5px;
}
</style>
